export const collections = [
  {
    id: 'living-room',
    slug: '/collections/living-room',
    name: 'Living Room',
    tagline: 'Where life comes together',
    description: 'From plush sectionals to sculptural coffee tables, craft a living room that\'s equal parts inviting and impressive.',
    productCount: 148,
    keywords: ['sofas', 'sectionals', 'coffee tables', 'accent chairs', 'TV consoles'],
    image: 'https://public.readdy.ai/ai/img_res/6d9de1676437ec48804e4ac73b8d655a.jpg',
    imageLandscape: 'https://readdy.ai/api/search-image?query=premium%20modern%20living%20room%20with%20designer%20velvet%20sofa%20plush%20accent%20chairs%20wood%20coffee%20table%20warm%20ambient%20lighting%20large%20windows%20high-end%20residential%20interior%20photography&width=1200&height=700&seq=col1l&orientation=landscape',
  },
  {
    id: 'bedroom',
    slug: '/collections/bedroom',
    name: 'Bedroom',
    tagline: 'Your personal sanctuary',
    description: 'Upholstered headboards, artisan nightstands, and luxurious dressers — everything you need for a bedroom you\'ll never want to leave.',
    productCount: 112,
    keywords: ['beds', 'headboards', 'nightstands', 'dressers', 'wardrobes'],
    image: 'https://readdy.ai/api/search-image?query=elegant%20master%20bedroom%20interior%20with%20upholstered%20platform%20bed%20premium%20linen%20bedding%20matching%20nightstands%20soft%20warm%20lighting%20sophisticated%20neutral%20palette%20luxury%20residential&width=900&height=700&seq=col2&orientation=landscape',
    imageLandscape: 'https://readdy.ai/api/search-image?query=luxury%20bedroom%20interior%20design%20upholstered%20king%20bed%20premium%20bedding%20warm%20ambient%20lighting%20wood%20floor%20stylish%20nightstands%20elegant%20neutral%20tones%20high-end%20photography&width=1200&height=700&seq=col2l&orientation=landscape',
  },
  {
    id: 'dining-room',
    slug: '/collections/dining-room',
    name: 'Dining Room',
    tagline: 'Gather in style',
    description: 'Make every meal an occasion. Our dining collections blend craftsmanship and elegance for tables worth lingering at.',
    productCount: 94,
    keywords: ['dining tables', 'chairs', 'buffets', 'bar carts', 'sideboards'],
    image: 'https://readdy.ai/api/search-image?query=sophisticated%20dining%20room%20interior%20with%20solid%20wood%20dining%20table%20designer%20chairs%20pendant%20chandelier%20warm%20atmospheric%20lighting%20elegant%20neutral%20decor%20high-end%20residential%20interior%20photography&width=900&height=700&seq=col3&orientation=landscape',
    imageLandscape: 'https://readdy.ai/api/search-image?query=elegant%20dining%20room%20with%20long%20dining%20table%20upholstered%20chairs%20dramatic%20chandelier%20warm%20wood%20floors%20beautiful%20architecture%20sophisticated%20atmosphere%20professional%20photography&width=1200&height=700&seq=col3l&orientation=landscape',
  },
  {
    id: 'home-office',
    slug: '/collections/home-office',
    name: 'Home Office',
    tagline: 'Designed for focus',
    description: 'Elevate your work-from-home experience with executive desks, ergonomic seating, and beautiful storage that performs as good as it looks.',
    productCount: 76,
    keywords: ['desks', 'office chairs', 'bookshelves', 'storage', 'file cabinets'],
    image: 'https://readdy.ai/api/search-image?query=sophisticated%20home%20office%20interior%20premium%20solid%20wood%20executive%20desk%20built-in%20bookshelves%20warm%20lighting%20elegant%20design%20productive%20space%20residential%20high-end%20interior%20photography&width=900&height=700&seq=col4&orientation=landscape',
    imageLandscape: 'https://readdy.ai/api/search-image?query=luxury%20home%20office%20with%20premium%20desk%20chair%20bookshelf%20warm%20ambient%20lighting%20sophisticated%20workspace%20elegant%20modern%20design%20professional%20residential%20interior&width=1200&height=700&seq=col4l&orientation=landscape',
  },
  {
    id: 'outdoor',
    slug: '/collections/outdoor',
    name: 'Outdoor',
    tagline: 'Extend your living space',
    description: 'Weather-resistant, beautifully crafted outdoor furniture that makes your terrace, patio, or garden a true extension of your home.',
    productCount: 65,
    keywords: ['patio sets', 'lounge chairs', 'outdoor sofas', 'dining sets', 'fire pits'],
    image: 'https://readdy.ai/api/search-image?query=luxury%20outdoor%20patio%20furniture%20premium%20lounge%20chairs%20sectional%20sofa%20terrace%20pool%20view%20beautiful%20architecture%20warm%20afternoon%20sunlight%20sophisticated%20exterior%20design&width=900&height=700&seq=col5&orientation=landscape',
    imageLandscape: 'https://readdy.ai/api/search-image?query=premium%20luxury%20outdoor%20terrace%20with%20designer%20patio%20furniture%20lounge%20chairs%20setting%20pool%20architecture%20beautiful%20afternoon%20light%20sophisticated%20outdoor%20living%20space&width=1200&height=700&seq=col5l&orientation=landscape',
  },
];

export const featuredProducts = [
  {
    id: 1,
    name: 'Meridian Velvet Sectional',
    collection: 'Living Room',
    slug: '/collections/living-room',
    price: '$4,299',
    originalPrice: '$5,199',
    badge: 'Best Seller',
    description: 'Sink into pure indulgence. Deep-set cushions, polished oak legs, and premium velvet upholstery.',
    image: 'https://readdy.ai/api/search-image?query=premium%20modern%20velvet%20sectional%20sofa%20in%20deep%20emerald%20green%20with%20polished%20wood%20legs%20elegant%20minimal%20living%20room%20setting%20white%20background%20soft%20ambient%20light%20high-end%20furniture%20photography&width=700&height=600&seq=prod1&orientation=landscape',
  },
  {
    id: 2,
    name: 'Oslo Platform Bed Frame',
    collection: 'Bedroom',
    slug: '/collections/bedroom',
    price: '$2,899',
    originalPrice: null,
    badge: 'New Arrival',
    description: 'Fluted walnut headboard, solid oak frame. Understated elegance that transforms your bedroom.',
    image: 'https://readdy.ai/api/search-image?query=premium%20upholstered%20platform%20bed%20frame%20linen%20headboard%20walnut%20wood%20modern%20minimalist%20design%20neutral%20background%20elegant%20bedroom%20furniture%20photography&width=700&height=600&seq=prod2&orientation=landscape',
  },
  {
    id: 3,
    name: 'Navarra Solid Oak Table',
    collection: 'Dining Room',
    slug: '/collections/dining-room',
    price: '$3,499',
    originalPrice: '$4,100',
    badge: 'Sale',
    description: '86" solid oak dining table with hand-oiled finish. Seats 8 comfortably, lasts a lifetime.',
    image: 'https://readdy.ai/api/search-image?query=solid%20oak%20dining%20table%20with%20natural%20wood%20grain%20beautiful%20craftsmanship%20minimalist%20modern%20design%20clean%20neutral%20background%20premium%20furniture%20product%20photography&width=700&height=600&seq=prod3&orientation=landscape',
  },
  {
    id: 4,
    name: 'Como Leather Lounge Chair',
    collection: 'Living Room',
    slug: '/collections/living-room',
    price: '$1,499',
    originalPrice: null,
    badge: null,
    description: 'Italian leather, sculptural walnut base. An accent chair that anchors any room with quiet confidence.',
    image: 'https://readdy.ai/api/search-image?query=premium%20Italian%20leather%20lounge%20accent%20chair%20sculptural%20walnut%20wood%20base%20modern%20elegant%20furniture%20design%20clean%20background%20warm%20studio%20lighting%20high-end%20product%20photography&width=700&height=600&seq=prod4&orientation=landscape',
  },
  {
    id: 5,
    name: 'Summit Executive Desk',
    collection: 'Home Office',
    slug: '/collections/home-office',
    price: '$2,199',
    originalPrice: null,
    badge: 'New Arrival',
    description: 'Solid walnut top, brass hardware, and integrated cable management. Built for serious work.',
    image: 'https://readdy.ai/api/search-image?query=premium%20solid%20walnut%20executive%20desk%20brass%20hardware%20minimal%20design%20high-end%20home%20office%20furniture%20clean%20neutral%20background%20sophisticated%20product%20photography&width=700&height=600&seq=prod5&orientation=landscape',
  },
  {
    id: 6,
    name: 'Riviera Outdoor Set',
    collection: 'Outdoor',
    slug: '/collections/outdoor',
    price: '$5,899',
    originalPrice: '$7,200',
    badge: 'Sale',
    description: 'All-weather woven rattan, teak accents, premium cushions. Your outdoor room, elevated.',
    image: 'https://readdy.ai/api/search-image?query=luxury%20outdoor%20patio%20furniture%20set%20all-weather%20woven%20rattan%20lounge%20chairs%20with%20teak%20accents%20premium%20cushions%20minimalist%20design%20outdoor%20product%20photography&width=700&height=600&seq=prod6&orientation=landscape',
  },
];
